// Gelişmiş NLP mantığı - Kendi eğitimimizle
export class CRVNLP {
  constructor() {
    // Eğitim verileri - kategoriler ve anahtar kelimeler
    this.trainingData = {
      'education': {
        keywords: [
          'eğitim', 'eğitimi', 'eğitimler', 'kurs', 'ders', 'öğrenme', 'öğrenmek', 'öğret', 'öğretmen', 'öğrenci',
          'mentor', 'mentorluk', 'workshop', 'seminer', 'akademi', 'üniversite', 'okul', 'sınıf',
          'eğitmen', 'hoca', 'öğretim', 'talimat', 'rehber', 'kılavuz', 'eğitim programı'
        ],
        phrases: [
          'eğitim veriyor', 'kurs var mı', 'ders alabilir miyim', 'öğrenebilir miyim',
          'eğitim programı', 'yazılım öğrenmek', 'programlama öğrenmek', 'kod yazmayı öğrenmek'
        ],
        weight: 1.0
      },
      'services': {
        keywords: [
          'hizmet', 'hizmetler', 'hizmeti', 'yazılım', 'geliştirme', 'uygulama', 'program', 'kod',
          'web', 'mobil', 'masaüstü', 'site', 'sistem', 'platform', 'çözüm', 'proje',
          'frontend', 'backend', 'fullstack', 'react', 'vue', 'angular', 'python', 'javascript', 'php',
          'android', 'ios', 'flutter', 'native', 'cross-platform'
        ],
        phrases: [
          'ne yapıyor', 'hizmetleriniz', 'yapıyor musunuz', 'geliştiriyor musunuz',
          'web sitesi', 'mobil uygulama', 'masaüstü program', 'yazılım geliştirme'
        ],
        weight: 0.9
      },
      'contact': {
        keywords: [
          'iletişim', 'telefon', 'email', 'e-posta', 'adres', 'kontak', 'ulaş', 'ulaşım',
          'bilgi', 'nere', 'nerede', 'nasıl', 'hangi', 'nelerdir', 'nedir',
          'whatsapp', 'mesaj', 'arama', 'çağrı', 'görüşme'
        ],
        phrases: [
          'iletişim bilgileri', 'telefon numarası', 'email adresi', 'nasıl ulaşabilirim',
          'nereye gidebilirim', 'hangi numarayı arayabilirim'
        ],
        weight: 0.8
      },
      'pricing': {
        keywords: [
          'fiyat', 'ücret', 'maliyet', 'bedel', 'tutar', 'parası', 'ne kadar', 'kaç para',
          'fiyatlandırma', 'maliyeti', 'ücreti', 'fiyatı', 'maliyetli', 'pahalı', 'ucuz',
          'teklif', 'quote', 'cost', 'price', 'budget', 'bütçe'
        ],
        phrases: [
          'fiyat bilgisi', 'ne kadar tutar', 'ücret nedir', 'maliyeti ne kadar',
          'fiyat teklifi', 'bütçe planlaması', 'ödeme şekli'
        ],
        weight: 0.9
      },
      'projects': {
        keywords: [
          'proje', 'projeler', 'portfolio', 'çalışma', 'örnek', 'referans', 'yaptığınız',
          'bitirdiğiniz', 'tamamladığınız', 'gerçekleştirdiğiniz', 'tamamlanan',
          'başarı', 'başarılı', 'sonuç', 'çıktı', 'ürün'
        ],
        phrases: [
          'projelerinizi görebilir miyim', 'hangi projeler yaptınız', 'referanslarınız',
          'portfolio', 'başarı hikayeleriniz', 'tamamlanan projeler'
        ],
        weight: 0.8
      },
      'about': {
        keywords: [
          'hakkımızda', 'kim', 'kimiz', 'şirket', 'ekip', 'takım', 'biz kimiz',
          'deneyim', 'uzmanlık', 'uzman', 'profesyonel', 'tecrübe', 'yıl',
          'misyon', 'vizyon', 'değer', 'değerlerimiz'
        ],
        phrases: [
          'hakkımızda bilgi', 'kimsiniz', 'şirketiniz hakkında', 'ekibiniz kim',
          'ne kadar deneyiminiz var', 'kaç yıllık tecrübeniz var'
        ],
        weight: 0.7
      },
      'technology': {
        keywords: [
          'teknoloji', 'teknolojiler', 'dil', 'diller', 'framework', 'araç', 'tool',
          'mysql', 'postgresql', 'mongodb', 'redis', 'api', 'rest', 'graphql',
          'aws', 'azure', 'google cloud', 'docker', 'kubernetes', 'ci/cd', 'devops'
        ],
        phrases: [
          'hangi teknolojileri kullanıyorsunuz', 'hangi dillerde çalışıyorsunuz',
          'teknoloji stack', 'araçlarınız neler', 'framework tercihiniz'
        ],
        weight: 0.8
      },
      'process': {
        keywords: [
          'süreç', 'proses', 'adım', 'aşama', 'nasıl', 'çalışıyor', 'işleyiş',
          'metodoloji', 'yaklaşım', 'yöntem', 'teknik', 'planlama', 'analiz',
          'tasarım', 'geliştirme', 'test', 'teslimat'
        ],
        phrases: [
          'nasıl çalışıyorsunuz', 'proje süreciniz', 'iş akışınız nasıl',
          'hangi aşamalardan geçiyor', 'metodolojiniz nedir'
        ],
        weight: 0.7
      },
      'ecommerce': {
        keywords: [
          'e-ticaret', 'ecommerce', 'online mağaza', 'satış', 'alışveriş', 'mağaza',
          'shopify', 'woocommerce', 'pazaryeri', 'marketplace', 'ürün', 'sepet',
          'ödeme', 'kargo', 'teslimat'
        ],
        phrases: [
          'e-ticaret sitesi', 'online mağaza', 'satış sitesi', 'alışveriş sitesi',
          'e-ticaret çözümü', 'mağaza yapabilir misiniz'
        ],
        weight: 0.8
      },
      'seo': {
        keywords: [
          'seo', 'pazarlama', 'marketing', 'google', 'arama', 'optimizasyon',
          'sosyal medya', 'instagram', 'facebook', 'twitter', 'linkedin',
          'reklam', 'kampanya', 'analitik', 'rapor'
        ],
        phrases: [
          'seo hizmeti', 'google aramalarda çıkmak', 'pazarlama yapabilir misiniz',
          'sosyal medya yönetimi', 'reklam verebilir misiniz'
        ],
        weight: 0.8
      },
      'security': {
        keywords: [
          'güvenlik', 'security', 'hack', 'ssl', 'sertifika', 'güvenli', 'güvenliği',
          'veri', 'data', 'privacy', 'kvkk', 'gdpr', 'şifreleme', 'encryption',
          'backup', 'yedek', 'kurtarma', 'recovery'
        ],
        phrases: [
          'güvenlik çözümü', 'veri güvenliği', 'ssl sertifikası', 'hack koruması',
          'backup hizmeti', 'veri kurtarma'
        ],
        weight: 0.8
      },
      'maintenance': {
        keywords: [
          'bakım', 'maintenance', 'destek', 'support', 'güncelleme', 'update',
          'hosting', 'sunucu', 'server', 'domain', 'alan adı', 'sistem yönetimi',
          'izleme', 'monitoring', 'log', 'rapor'
        ],
        phrases: [
          'bakım hizmeti', 'teknik destek', 'hosting hizmeti', 'sistem yönetimi',
          '7/24 destek', 'güncelleme hizmeti'
        ],
        weight: 0.8
      },
      'mobile': {
        keywords: [
          'mobil uygulama', 'mobile app', 'app store', 'play store', 'native',
          'hybrid', 'react native', 'flutter', 'xamarin', 'ios', 'android',
          'smartphone', 'tablet', 'pwa', 'progressive web app'
        ],
        phrases: [
          'mobil uygulama yapabilir misiniz', 'app store yayınlama', 'play store yayınlama',
          'ios uygulaması', 'android uygulaması', 'cross-platform uygulama'
        ],
        weight: 0.9
      },
      'design': {
        keywords: [
          'tasarım', 'design', 'ui', 'ux', 'responsive', 'modern', 'görsel',
          'logo', 'branding', 'kurumsal kimlik', 'identity', 'marka',
          'renk', 'tipografi', 'font', 'icon', 'grafik'
        ],
        phrases: [
          'web tasarım', 'logo tasarımı', 'kurumsal kimlik', 'ui tasarımı',
          'ux tasarımı', 'responsive tasarım', 'modern tasarım'
        ],
        weight: 0.8
      },
      'database': {
        keywords: [
          'veritabanı', 'database', 'api', 'mysql', 'postgresql', 'mongodb',
          'redis', 'sql', 'nosql', 'rest api', 'graphql', 'json', 'xml',
          'endpoint', 'webhook', 'integration', 'entegrasyon'
        ],
        phrases: [
          'veritabanı tasarımı', 'api geliştirme', 'rest api', 'graphql api',
          'veritabanı optimizasyonu', 'api entegrasyonu'
        ],
        weight: 0.8
      },
      'cloud': {
        keywords: [
          'bulut', 'cloud', 'aws', 'azure', 'google cloud', 'docker', 'kubernetes',
          'ci/cd', 'devops', 'deployment', 'scaling', 'load balancing',
          'microservice', 'container', 'orchestration'
        ],
        phrases: [
          'bulut çözümü', 'aws hizmeti', 'azure migration', 'docker container',
          'kubernetes orchestration', 'devops hizmeti'
        ],
        weight: 0.8
      },
      'payment': {
        keywords: [
          'ödeme', 'payment', 'fatura', 'invoice', 'taksit', 'kredi kartı',
          'banka', 'havale', 'eft', 'pos', 'terminal', 'gateway',
          'stripe', 'paypal', 'iyzico', 'param', 'turkcell'
        ],
        phrases: [
          'ödeme sistemi', 'fatura sistemi', 'kredi kartı ödemesi', 'banka havalesi',
          'taksitli ödeme', 'pos sistemi'
        ],
        weight: 0.8
      }
    };

    // Bağlam analizi için önceki mesajları sakla
    this.conversationContext = [];
    this.maxContextLength = 5;
  }

  // Ana analiz fonksiyonu
  analyzeMessage(message) {
    const normalizedMessage = this.normalizeText(message);
    const intentScores = this.calculateIntentScores(normalizedMessage);
    const bestIntent = this.getBestIntent(intentScores);
    const confidence = intentScores[bestIntent] || 0;

    // Bağlamı güncelle
    this.updateContext({
      message: normalizedMessage,
      intent: bestIntent,
      confidence: confidence,
      timestamp: new Date()
    });

    return {
      intent: bestIntent,
      confidence: confidence,
      scores: intentScores,
      context: this.getRelevantContext(bestIntent)
    };
  }

  // Metin normalleştirme
  normalizeText(text) {
    return text.toLowerCase()
      .replace(/[.,!?;:]/g, '') // Noktalama işaretlerini kaldır
      .replace(/\s+/g, ' ') // Çoklu boşlukları tek boşluğa çevir
      .trim();
  }

  // Intent skorlarını hesapla
  calculateIntentScores(message) {
    const scores = {};
    const words = message.split(' ');
    
    // Her kategori için skor hesapla
    Object.keys(this.trainingData).forEach(intent => {
      const category = this.trainingData[intent];
      let score = 0;

      // Anahtar kelime skorları
      category.keywords.forEach(keyword => {
        if (message.includes(keyword)) {
          score += 1.0; // Tam eşleşme
        }
        
        // Kelime bazında eşleşme
        words.forEach(word => {
          if (word.includes(keyword) || keyword.includes(word)) {
            score += 0.5; // Kısmi eşleşme
          }
        });
      });

      // Cümle kalıbı skorları
      category.phrases.forEach(phrase => {
        if (message.includes(phrase)) {
          score += 2.0; // Cümle kalıbı eşleşmesi daha yüksek skor
        }
      });

      // Ağırlık çarpanı uygula
      score *= category.weight;
      
      // Bağlam bonusu
      score += this.getContextBonus(intent);
      
      scores[intent] = score;
    });

    return scores;
  }

  // En iyi intent'i bul
  getBestIntent(scores) {
    let bestIntent = 'default';
    let bestScore = 0;

    Object.keys(scores).forEach(intent => {
      if (scores[intent] > bestScore) {
        bestScore = scores[intent];
        bestIntent = intent;
      }
    });

    // Minimum güven eşiği
    return bestScore > 0.5 ? bestIntent : 'default';
  }

  // Bağlam bonusu hesapla
  getContextBonus(intent) {
    if (this.conversationContext.length === 0) return 0;

    let bonus = 0;
    const recentContext = this.conversationContext.slice(-3); // Son 3 mesaj

    recentContext.forEach(context => {
      if (context.intent === intent) {
        bonus += 0.3; // Aynı kategoride devam eden konuşma
      }
    });

    return bonus;
  }

  // Bağlamı güncelle
  updateContext(contextData) {
    this.conversationContext.push(contextData);
    
    // Maksimum bağlam uzunluğunu koru
    if (this.conversationContext.length > this.maxContextLength) {
      this.conversationContext.shift();
    }
  }

  // İlgili bağlamı al
  getRelevantContext(intent) {
    return this.conversationContext.filter(ctx => ctx.intent === intent);
  }

  // Konuşmayı sıfırla
  resetConversation() {
    this.conversationContext = [];
  }

  // Eğitim verilerini güncelle
  updateTrainingData(intent, keywords = [], phrases = []) {
    if (!this.trainingData[intent]) {
      this.trainingData[intent] = { keywords: [], phrases: [], weight: 0.8 };
    }

    this.trainingData[intent].keywords.push(...keywords);
    this.trainingData[intent].phrases.push(...phrases);
  }

  // NLP istatistikleri
  getStats() {
    return {
      totalCategories: Object.keys(this.trainingData).length,
      totalKeywords: Object.values(this.trainingData).reduce((sum, cat) => sum + cat.keywords.length, 0),
      totalPhrases: Object.values(this.trainingData).reduce((sum, cat) => sum + cat.phrases.length, 0),
      conversationLength: this.conversationContext.length
    };
  }
}

// Singleton instance
export const nlpEngine = new CRVNLP();
